import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getMessaging, getToken } from 'firebase/messaging';

// আপনার ফায়ারবেইজ প্রজেক্ট কনফিগারেশন
const firebaseConfig = {
  apiKey: "AIzaSyDneEF_nmzgRA_zAjLJJdc24mcwoTlkDxw",
  authDomain: "earneedss.firebaseapp.com",
  projectId: "earneedss",
  storageBucket: "earneedss.firebasestorage.app",
  messagingSenderId: "998984970434",
  appId: "1:998984970434:web:66251f04f97e1b054f4b5b",
  measurementId: "G-WCNE9B1RMD"
};

// ফায়ারবেইজ ইনিশিয়ালাইজেশন
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

const supportsMessaging = typeof window !== 'undefined'
  && 'serviceWorker' in navigator
  && 'Notification' in window
  && 'PushManager' in window
  && (window.location.protocol === 'https:'
    || window.location.hostname === 'localhost'
    || window.location.hostname === '127.0.0.1');

export const messaging = supportsMessaging ? getMessaging(app) : null;

export const getFcmToken = async (registration) => {
  if (!messaging) {
    console.warn('FCM unsupported in this browser or insecure context.');
    return null;
  }

  try {
    const options = registration ? { serviceWorkerRegistration: registration } : {};
    const token = await getToken(messaging, options);
    return token;
  } catch (error) {
    console.error('FCM getToken error:', error);
    return null;
  }
};

export default app;